module.exports = __webpack_public_path__ + "media/images/application/icons/close-modal-4518c7c4e95e884b00aa49585436a5d4.svg";